import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=779276b0&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=779276b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779276b0",
  null
  
)

export default component.exports